import type { DiscoveredRouteModule } from '@/router/generator/types';
import { markRaw, defineAsyncComponent } from 'vue';

const AdminEventsView = () => import('@/views/admin/EventsView.vue');
const AdminEventsHeaderComponent = defineAsyncComponent(() => import('@/components/app/admin/events/HeaderComponent.vue'));

export const NAME_ADMIN_EVENTS = 'AdminEvents';
export const PATH_ADMIN_EVENTS = 'events';

export const route: DiscoveredRouteModule = {
  id: 'admin.events',
  scope: 'admin',
  moduleKey: 'events',
  name: NAME_ADMIN_EVENTS,
  path: PATH_ADMIN_EVENTS,
  component: AdminEventsView,
  meta: {
    requiresAdmin: true,
    dynamicComponent: markRaw(AdminEventsHeaderComponent),
    dynamicComponentScale: 'scale-75',
    dataLoaders: ['project_document', 'features', 'project_events', 'project_channels', 'portal_base', 'project_user_fields'],
  },
};
